import styled, { css } from 'styled-components';

import { Modal } from '../../index';
import { ContentContainer } from '../../styled';

interface IStyledModal {
    isSuccess: boolean;
}

export const StyledModal = styled(Modal)<IStyledModal>`
    ${ContentContainer} {
        ${({ isSuccess, theme }) => css`
            width: ${isSuccess && '21rem'};
            transition: width ${theme.transitions.hover};
        `}
    }
`;
